import { trpc } from '@/shared/api';

/** HOME 함께한 브랜드(portfolio.clientLogos) — 고객사명·로고가 모두 있는 공개 사례의 로고. 배열 순서가 노출 순서다. */
export const useClientLogosQuery = () =>
  trpc.portfolio.clientLogos.useQuery(undefined, { retry: false });
